// extracted by mini-css-extract-plugin
export default {"title":"AdjustmentsContainer_title__GGqmT","container":"AdjustmentsContainer_container__dL-KY","showAll":"AdjustmentsContainer_showAll__pnibz"};